/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import building from "assets/images/building.png";
import DataTable from "examples/Tables/DataTable";
import { Button, Card, CircularProgress, Icon, MenuItem } from "@mui/material";
import applicator from "ajv/dist/vocabularies/applicator";
import colors from "assets/theme/base/colors";
import { useNavigate } from "react-router-dom";
import { useMemo, useCallback, useState, useRef, useEffect } from "react";
import moment from "moment";
import { NumberFormatter } from "utilities";
import debounce from "lodash.debounce";
import { getAllJobs } from "api";
import { getCities } from "api";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { jobStatus } from "utilities";
import { statusColors } from "utilities";
import { getJobType } from "api";
import { exportToExcel } from "utilities";

const Job = ({ name, detail, location }) => (
  <MDBox gap={2}>
    <MDTypography
      display="block"
      variant="button"
      fontWeight="medium"
      pt={1}
      noWrap
      sx={{
        maxWidth: "300px",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      {name}
    </MDTypography>
    <MDTypography display="block" variant="caption">
      {detail}
    </MDTypography>
    {/* <MDTypography variant="caption">{location}</MDTypography> */}
  </MDBox>
);

export default function data({ company }) {
  const navigate = useNavigate();
  const [list, setList] = useState([]);

  const [skip, setSkip] = useState();
  const limit = 10000;
  const [search, setSearch] = useState();
  const [loading, setLoading] = useState(false);

  const arrStatus = [
    { key: "all", name: "All" },
    { key: "active", name: "Active" },
    { key: "pending", name: "Pending" },
    { key: "closed", name: "Closed" },
  ];
  const [status, setStatus] = useState(arrStatus[0]);

  const [arrJobType, setArrJobType] = useState([{ _id: "0", name: "All" }]);
  const [jobType, setJobType] = useState(arrJobType[0]);

  const [arrLocation, setArrLocation] = useState([{ name: "All" }]);
  const [location, setLocation] = useState(arrLocation[0]);

  useEffect(() => {
    onSearchData("");
    getLocationApi();
    getJobTypeApi();
  }, []);

  useEffect(() => {
    if (search !== undefined) {
      if (skip === 0) {
        getAllJobsApi();
      } else {
        setSkip(0);
      }
    }
  }, [search]);

  useEffect(() => {
    if (skip !== undefined) {
      getAllJobsApi();
    }
  }, [skip]);

  const debouncedFetch = useRef(
    debounce((searchVal) => {
      setSearch(searchVal);
    }, 500)
  ).current;

  const getAllJobsApi = (isReset = false) => {
    var params = {
      type: "admin",
      companyId: company?._id,
      title: search,
      skip: skip,
      limit: limit,
    };

    if (isReset) {
      params.status = "all";
      params.location = [];
      params.jobType = [];
    } else {
      params.status = status?.key || "all";
      params.location = location?.name.toLowerCase() == "all" ? [] : [location?.name];
      params.jobType = jobType?.name.toLowerCase() == "all" ? [] : [jobType];
    }

    setLoading(true);
    getAllJobs({
      params: params,
    })
      .then((responseJson) => {
        if (skip === 0) {
          setList(responseJson?.jobs);
        } else {
          setList([...list, ...responseJson?.jobs]);
        }
      })
      .catch((e) => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const getJobTypeApi = () => {
    var params = {
      page: 1,
      limit: 1000,
      type: "all",
    };
    getJobType({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            setArrJobType([...arrJobType, ...responseJson?.jobType]);
          }
        }
      })
      .catch((e) => {})
      .finally(() => {});
  };

  const getLocationApi = () => {
    var params = {
      page: 1,
      limit: 1000,
    };

    getCities({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            setArrLocation([...arrLocation, ...responseJson?.cities]);
          }
        }
      })
      .catch((e) => {})
      .finally(() => {});
  };

  const onSearchData = (val) => {
    debouncedFetch(val);
  };

  const handleAction = useCallback(
    (item) => {
      navigate("/jobs/job-details", { state: { job: item } });
    },
    [navigate]
  );

  const handleApplicant = useCallback(
    (item) => {
      navigate("/jobs/all-applicants", { state: { job: item } });
    },
    [navigate]
  );

  const columns = useMemo(() => {
    return [
      { Header: "jobs", accessor: "jobs", align: "left" },
      { Header: "company", accessor: "company", align: "left" },
      { Header: "posted on", accessor: "posted", align: "center" },
      { Header: "status", accessor: "status", align: "center" },
      { Header: "applicants", accessor: "applicants", align: "center" },
      {
        Header: "actions",
        accessor: "action",
        align: "center",
      },
    ];
  }, []);

  const Company = ({ name, detail, image }) => {
    const imgWidth = image ? "100%" : "50%";
    const imgHeight = image ? "100%" : "50%";
    const imgResize = image ? "cover" : "contain";
    return (
      <MDBox display="flex" gap={1} alignItems="center">
        <MDAvatar
          src={image || building}
          size="sm"
          sx={{
            width: "35px", // optional: control size
            height: "35px", // optional: control size
            border: "2px solid",
            borderColor: "success.main",
            "& img": {
              width: imgWidth,
              height: imgHeight,
              objectFit: imgResize,
              objectPosition: "center",
            },
          }}
        />
        <MDBox>
          <MDTypography
            display="block"
            variant="caption"
            fontWeight="medium"
            noWrap
            sx={{
              maxWidth: "300px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {name}
          </MDTypography>
          <MDTypography variant="caption" noWrap>
            {detail}
          </MDTypography>
        </MDBox>
      </MDBox>
    );
  };

  const rows = useMemo(() => {
    var rowsData = [];

    list.map((item) =>
      rowsData.push({
        jobs: (
          <Job
            name={item?.title}
            detail={item?.jobType.map((item) => item?.name).join(", ")}
            location={item?.location?.join(", ")}
          />
        ),
        company: (
          <Company
            name={item?.company?.businessName}
            // detail={`${item?.company?.city}, ${item?.company?.state}, ${item?.company?.country}`}
            detail={item?.location?.join(", ")}
            image={item?.company?.businessImageURL}
          />
        ),
        posted: (
          <MDBox sx={{ px: 1 }}>
            <MDTypography variant="caption" noWrap>{`${moment(item?.createdAt).format(
              "DD MMM YYYY"
            )}`}</MDTypography>
          </MDBox>
        ),
        status: (
          <MDBox sx={{ px: 1 }}>
            <MDBadge
              badgeContent={jobStatus[item?.status] || "Pending"}
              color={statusColors[item?.status] || "secondary"}
              variant="gradient"
              size="sm"
              // sx={{ cursor: "pointer" }}
              circular
            ></MDBadge>
          </MDBox>
        ),
        applicants: (
          <MDBox
            display="flex"
            gap={0.5}
            color="secondary"
            sx={{ px: 1, cursor: "pointer" }}
            onClick={() => handleApplicant(item)}
          >
            <MDBadge
              badgeContent={NumberFormatter(parseInt(item?.applicantCount || 0))}
              color={"light"}
              variant="gradient"
              size="sm"
              circular
            />
            <Icon fontSize="small">people_alt</Icon>
          </MDBox>
        ),
        action: (
          <MDBox onClick={() => handleAction(item)}>
            <MDTypography
              component="a"
              variant="caption"
              color="secondary"
              fontWeight="medium"
              sx={{ px: 1, cursor: "pointer" }}
            >
              <Icon fontSize="small">arrow_forward</Icon>
            </MDTypography>
          </MDBox>
        ),
      })
    );

    return rowsData;
  }, [list, Job]);

  const handleApplyFilter = () => {
    getAllJobsApi();
  };
  const handleResetFilter = () => {
    setStatus(arrStatus[0]);
    setJobType(arrJobType[0]);
    setLocation(arrLocation[0]);

    getAllJobsApi(true);
  };

  const handleExport = () => {
    exportToExcel(list, "jobs.xlsx");
  };

  const ViewFilter = () => {
    return (
      <Card sx={{ mb: 3 }}>
        <MDBox
          p={3}
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          flexWrap="wrap"
          gap={2}
        >
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              select
              label="Job Type"
              value={JSON.stringify(jobType)}
              onChange={(e) => setJobType(JSON.parse(e.target.value))}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      maxWidth: 200,
                    },
                  },
                },
              }}
            >
              {arrJobType.map((item) => (
                <MenuItem key={item?._id} value={JSON.stringify(item)}>
                  {item?.name}
                </MenuItem>
              ))}
            </MDInput>
          </MDBox>
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              select
              label="Location"
              value={JSON.stringify(location)}
              onChange={(e) => setLocation(JSON.parse(e.target.value))}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      maxWidth: 200,
                    },
                  },
                },
              }}
            >
              {arrLocation.map((item, index) => (
                <MenuItem key={index} value={JSON.stringify(item)}>
                  {item?.name}
                </MenuItem>
              ))}
            </MDInput>
          </MDBox>

          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              select
              label="Status"
              value={JSON.stringify(status)}
              onChange={(e) => setStatus(JSON.parse(e.target.value))}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
            >
              {arrStatus.map((item) => (
                <MenuItem key={item?.key} value={JSON.stringify(item)}>
                  {item?.name}
                </MenuItem>
              ))}
            </MDInput>
          </MDBox>
        </MDBox>
        <MDBox
          mb={3}
          ml={3}
          mr={3}
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          gap={2}
        >
          <MDBox display="flex" flexDirection={{ xs: "column", sm: "row" }} gap={2}>
            <MDButton onClick={handleApplyFilter} color="success">
              apply
            </MDButton>
            <Button onClick={handleResetFilter} color="error" variant="contained">
              reset
            </Button>
          </MDBox>
          <MDButton onClick={handleExport} color="secondary" variant="contained">
            export
          </MDButton>
        </MDBox>
      </Card>
    );
  };

  return (
    <MDBox>
      <ViewFilter />
      <Card>
        <MDBox p={3} sx={{ width: "100%", overflowX: "auto" }}>
          <DataTable
            table={{ columns, rows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={true}
            canSearch={true}
            noEndBorder
            onSearch={(val) => {
              onSearchData(val);
            }}
          />
          {loading && (
            <MDBox display="flex" justifyContent="center" mt={2}>
              <CircularProgress size={24} color="success" />
            </MDBox>
          )}
        </MDBox>
      </Card>
    </MDBox>
  );
}
